import { render } from "./TestimonialFormPage.vue?vue&type=template&id=6be7252f&scoped=true&ts=true"
import script from "./TestimonialFormPage.vue?vue&type=script&lang=ts"
export * from "./TestimonialFormPage.vue?vue&type=script&lang=ts"

import "./TestimonialFormPage.vue?vue&type=style&index=0&id=6be7252f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be7252f"]])

export default __exports__